import type React from 'react';

import { useAvailablePeriod } from '@entities/available-periods';

type Props = {
	id: number;
};

export const AvailablePeriodAddress: React.FC<Props> = ({ id }) => {
	const { availablePeriod } = useAvailablePeriod(id);

	const getAddress = () => {
		if (!availablePeriod || availablePeriod.address.length === 0) return;

		const address = availablePeriod.address[0];

		return `г. ${address.city}, ул. ${address.street}, д. ${address.house} `;
	};

	return <>{getAddress()}</>;
};
